angular
  .module('tasks')
  .directive('taskActivityComment', ["PATH", "localStorageService", "notificationCommentParser", "taskManagementService", "$sce", function (
    PATH,
    localStorageService,
    notificationCommentParser,
    taskManagementService,
    $sce
  ) {
    return {
      restrict: 'E',
      scope: {
        activityComment: '=',
        managers: '=',
        cardMembers: '=',
        onUpdate: '&',
        onRemove: '&'
      },
      templateUrl: PATH.components + 'taskManagement/comment/view.html',
      link: function ($scope) {
        $scope.mentions = getMentions();

        function getMentions() {
          return taskManagementService.getMentions(
            $scope.managers,
            $scope.cardMembers
          );
        }
        $scope.oldMentions = [];
        $scope.activityComment.createTime = moment($scope.activityComment.createTime).subtract(6, 'hours').format('MMM d, h:mm:ss a');
        $scope.$watch('cardMembers', function () {
          $scope.mentions = getMentions();
        });
        var userInfo = localStorageService.get('userInfo');
        $scope.isAuthor = $scope.activityComment.user.login == userInfo.login;
        $scope.inEdit = false;
        $scope.commentUpdated = $scope.activityComment.comment;
        $scope.transactionComment = '';
        $scope.commentTransactionDesc = $scope.activityComment.hasOwnProperty('transactionId') ? taskManagementService.getTransactionDescription($scope.activityComment.transactionId) : '';
        if ($scope.commentTransactionDesc) {
          $scope.commentTransactionDesc.then(function (res) {
            $scope.transactionComment = res.data;
          });
        }
        $scope.getCommentFormatted = function () {
          if ($scope.activityComment.hasOwnProperty('transactionId')) {
            var username = $scope.activityComment.user.hasOwnProperty('firstName')
                ? '<b>' +
                $scope.activityComment.user.firstName + ' ' +
                $scope.activityComment.user.lastName +
                '</b>'
                : '';
            if (!username) {
              username = $scope.activityComment.user.login;
            }
            var commentBodyDiv =
                '<div class="transaction-comment-wrapper">' +
              // eslint-disable-next-line max-len
                "<span class='transaction-comment'></span>" + $scope.activityComment.comment + '</div>';
            var comment =
                '<b>' + username + '</b>' +
                ' provided feedback on the following transaction on ' +
                  moment($scope.activityComment.createTime).subtract(6, 'hours').format('MMM d, h:mm:ss a') +
                '<br/>' +
              // eslint-disable-next-line max-len
                "<a transactionid='" + $scope.activityComment.transactionId + "' class='transaction-redirect' href='#'>" +
                $scope.transactionComment + '</a> ' +
                commentBodyDiv;
            return $sce.trustAsHtml(notificationCommentParser.parse(comment));
          } else {
            return notificationCommentParser.parse(
              $scope.activityComment.comment
            );
          }
        };

        $scope.editComment = function (e) {
          $scope.inEdit = true;
          // eslint-disable-next-line max-len
          $scope.oldMentions = taskManagementService.getUsersMentioned(
            $scope.activityComment.comment,
            $scope.mentions
          );
          e.stopPropagation();
          e.preventDefault();
        };
        $scope.removeComment = function (e) {
          $scope.onRemove({ activityComment: $scope.activityComment });
          e.stopPropagation();
          e.preventDefault();
        };
        $scope.cancelEdit = function () {
          $scope.inEdit = false;
          $scope.commentUpdated = $scope.activityComment.comment;
        };
        $scope.save = function (comment) {
          $scope.activityComment.comment = comment;
          // eslint-disable-next-line max-len
          $scope.onUpdate({
            activityComment: $scope.activityComment,
            mentions: taskManagementService.getUsersMentioned(
              comment,
              $scope.mentions
            ),
            oldMentions: $scope.oldMentions
          });
          $scope.commentUpdated = comment;
          $scope.inEdit = false;
        };
      }
    };
  }]);



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/taskManagement/comment/directive.js